import React from 'react';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';

type Props = {
  payRate: string | null;
};

const usePayRateStyles = makeStyles((theme) => createStyles({
  payRate: {
    fontStyle: 'italic',
    fontSize: '12px',
    lineHeight: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
    margin: 0,
    minHeight: '14px',
  }
}));

export const ShiftCardPayRate = ({ payRate }: Props) => {
  const styles = usePayRateStyles();
  
  if (!payRate) {
    return null;
  }

  return (
    <div className={clsx('shift-card-view__pay-rate')}>
      <p className={styles.payRate}>{payRate}</p>
    </div>
  );
};

